import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cba5787"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component creatine" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title__text" }, "크레아티닌 검사 이력", -1))
const _hoisted_3 = { class: "table__box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "검사일자")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "검사결과")
], -1))
const _hoisted_5 = { class: "table__body my-scroll" }
const _hoisted_6 = { class: "table__tr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientInfo.CREATININE, (creatinine) => {
          return (_openBlock(), _createElementBlock("div", { key: creatinine }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(_ctx.moment(new Date(creatinine.CREATININE_DTE)).format('YYYY-MM-DD HH:mm')), 1),
              _createElementVNode("div", null, _toDisplayString(creatinine.CREATININE_RSLT), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}